import MedsImage from 'assets/images/partner-recs/meds.svg?react';
import { CTACard } from 'components/CTACard/CTACard';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import useGetMobilePartnerNotesItems from 'hooks/partnerNotes/mobile/useGetMobilePartnerNotesItems';
import { useNavigate } from 'react-router-dom';

type Props = {
  className?: string;
};

export default function PartnerRecsCard({ className }: Props) {
  const [firstPartnerNote] = useGetMobilePartnerNotesItems();
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  if (!firstPartnerNote) return null;

  function handleClick() {
    trackEvent('Partner Recs AP Card Clicked');
    navigate(`/partner-recs/${firstPartnerNote.partner.id}`);
  }

  return (
    <CTACard
      label={`View recommendations from ${firstPartnerNote.partner.name}`}
      image={MedsImage}
      containerClassName={className}
      action={{
        label: 'View',
        onClick: handleClick,
      }}
    />
  );
}
